import React from 'react';
import { Share2, Link as LinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useProfileShare } from '../hooks/useProfileShare';

export const ProfileShareMenuItems = ({ username, testPrefix, onAction }) => {
  const { t } = useTranslation('profile');
  const { shareProfile, copyProfileLink } = useProfileShare(username);
  const items = [
    { key: 'share', icon: Share2, label: t('share.action'), run: shareProfile },
    { key: 'copy-link', icon: LinkIcon, label: t('share.copy_link'), run: copyProfileLink },
  ];
  return (
    <div className="border-b border-border">
      {items.map(({ key, icon: Icon, label, run }) => (
        <button
          key={key}
          type="button"
          onClick={() => { run(); onAction(); }}
          className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm font-semibold transition-colors hover:bg-muted focus-visible:bg-muted"
          data-testid={`${testPrefix}-${key}-btn`}
        >
          <Icon className="h-4 w-4 shrink-0" aria-hidden="true" /> {label}
        </button>
      ))}
    </div>
  );
};